import { Link } from "react-router-dom";
import EmcLogo from "../../atoms/logos/emcLogo/EmcLogo";
import "./Footer.css";
import React, { useEffect, useRef, useState } from "react";
import RoundedDiv from "../../atoms/icons/general/roundedDiv/RoundedDiv";
import NewsletterForm from "../../forms/account/newsletterForm/NewsletterForm";
import { fetchAllConseilsProsApi, fetchAllGuideAgentsImmosApi } from "../../../api/ToolsApi";
import { getPrettyText, toggleCollapseElement } from "../../../utils/Utils";
import Bracket from "../../atoms/icons/general/bracket/Bracket";

function Footer() {
  const [conseilsPros, setConseilsPros] = useState([]);
  const [conseilsProsVisible, setConseilsProsVisible] = useState(false);
  const [guidesAgentsImmos, setGuidesAgentsImmos] = useState([]);
  const [guidesAgentsImmosVisible, setGuidesAgentsImmosVisible] = useState(false);

  const conseilsProsRef = useRef(null);
  const guidesAgentsImmosRef = useRef(null);

  useEffect(() => {
    fetchConseilsPros();
    fetchGuidesAgentsImmos();
  }, []);

  useEffect(() => {
    if (conseilsProsRef.current) toggleCollapseElement(conseilsProsRef.current, conseilsProsVisible);
  }, [conseilsProsVisible]);

  useEffect(() => {
    if (guidesAgentsImmosRef.current) toggleCollapseElement(guidesAgentsImmosRef.current, guidesAgentsImmosVisible);
  }, [guidesAgentsImmosVisible]);

  async function fetchConseilsPros() {
    try {
      const res = (await fetchAllConseilsProsApi(0, 1000)).data.conseils_pros;
      setConseilsPros(res);
    } catch (error) {}
  }

  async function fetchGuidesAgentsImmos() {
    try {
      const res = (await fetchAllGuideAgentsImmosApi()).data;
      setGuidesAgentsImmos(res);
    } catch (error) {}
  }

  return (
    <>
      <section className='footer-container'>
        <RoundedDiv className='footer-top' />
        <div className='container footer-content'>
          <div>
            <EmcLogo width='300px' className='footer-logo' />
            <ul>
              <li>
                <Link to='mailto:contact@estimermoncommerce.fr'>contact@estimermoncommerce.fr</Link>
              </li>
              <li>41-43 rue de Cronstadt</li>
              <li>75015 Paris</li>
            </ul>
          </div>
          <div>
            <div className='footer-title'>Liens légaux</div>
            <ul>
              <li>
                <Link to='/politique-confidentialite'>Politique de confidentialité</Link>
              </li>
              <li>
                <Link to='/mentions-legales'>Mentions légales</Link>
              </li>
              <li>
                <Link to='/parametrage-cookies'>Gérer les cookies</Link>
              </li>
              <li>
                <Link to='/cgu'>C.G.U</Link>
              </li>
              <li>
                <Link to='/cgv'>C.G.V</Link>
              </li>
            </ul>
          </div>
          <div>
            <div className='footer-title'>Ressources</div>
            <ul>
              <li>
                <Link to='/outils-pratiques'>Outils pratiques</Link>
              </li>
              <li>
                <Link to='/lexique'>Lexique</Link>
              </li>
              {/* <li>
                <Link to='/annonces'>Les annonces</Link>
              </li> */}
              <li>
                <Link to='/faq'>F.A.Q</Link>
              </li>
              <li>
                <Link to='/conseils-pros'>Conseils de pros</Link>
              </li>
            </ul>
            <div>
              <div className='footer-expand-button' onClick={() => setConseilsProsVisible(prev => !prev)}>
                {conseilsProsVisible ? "Cacher les conseils de pros" : "Voir tous les conseils de pros"}
                <Bracket rotation={conseilsProsVisible ? "180deg" : "90deg"} width='10px' className='ml-xs' />
              </div>
              <ul className='footer-articles-container' ref={conseilsProsRef}>
                {conseilsPros.map(article => (
                  <li key={article.id}>
                    <Link to={`/conseils-pros/${article.url}`}>{getPrettyText(article.title)}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <ul>
              <li>
                <Link to='/philosophie'>Méthode & philosophie</Link>
              </li>
              <li>
                <Link to='/guides-agents-immos'>Nos guides pour agents immos</Link>
              </li>
            </ul>
            <div>
              <div className='footer-expand-button' onClick={() => setGuidesAgentsImmosVisible(prev => !prev)}>
                {guidesAgentsImmosVisible
                  ? "Cacher les guides pour agents immos"
                  : "Voir tous les guides pour agents immos"}
                <Bracket rotation={guidesAgentsImmosVisible ? "180deg" : "90deg"} width='10px' className='ml-xs' />
              </div>
              <ul className='footer-articles-container' ref={guidesAgentsImmosRef}>
                {guidesAgentsImmos.map(article => (
                  <li key={article.id}>
                    <Link to={`/guides-agents-immos/${article.newsletter_url}`}>{getPrettyText(article.title)}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <ul>
              <li>
                <Link to='/simulateur-credit'>Simulateur de crédit</Link>
              </li>
              <li>
                <Link to='/plan-financement'>Plan de financement</Link>
              </li>
              <li>
                <Link to='/calculateur-cotisations'>Calculateur de cotisations</Link>
              </li>
              <li>
                <Link to='/liste-activites'>Liste des activités</Link>
              </li>
              <li>
                <Link to='/exemples-rapports'>Exemples de rapports</Link>
              </li>
              <li>
                <Link to='/contact'>Nous contacter</Link>
              </li>
            </ul>
          </div>
          <div>
            <div className='footer-title'>Newsletter</div>
            <NewsletterForm />
          </div>
        </div>
      </section>
    </>
  );
}

export default Footer;
